var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInstagramIcon = function SvgInstagramIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 26",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagramIcon_svg__a)",
    d: "M18.255 0H7.745C3.476 0 0 3.475 0 7.746v10.509C0 22.525 3.475 26 7.746 26h10.509C22.525 26 26 22.525 26 18.255V7.745C26 3.476 22.525 0 18.255 0m5.13 18.255a5.13 5.13 0 0 1-5.13 5.13H7.745a5.13 5.13 0 0 1-5.13-5.13V7.745a5.13 5.13 0 0 1 5.13-5.13h10.51a5.13 5.13 0 0 1 5.13 5.13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagramIcon_svg__b)",
    d: "M13 6.275a6.73 6.73 0 0 0-6.725 6.724A6.73 6.73 0 0 0 13 19.724a6.73 6.73 0 0 0 6.724-6.725A6.73 6.73 0 0 0 13 6.275m0 10.833a4.109 4.109 0 1 1 0-8.218 4.109 4.109 0 0 1 0 8.218"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#instagramIcon_svg__c)",
    d: "M19.737 7.937a1.611 1.611 0 1 0 0-3.223 1.611 1.611 0 0 0 0 3.223"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagramIcon_svg__a",
    x1: 13,
    x2: 13,
    y1: 25.924,
    y2: 0.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagramIcon_svg__b",
    x1: 13,
    x2: 13,
    y1: 25.924,
    y2: 0.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "instagramIcon_svg__c",
    x1: 19.737,
    x2: 19.737,
    y1: 25.924,
    y2: 0.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInstagramIcon);
export default ForwardRef;